import { render } from "./UnidadeTable.vue?vue&type=template&id=2da755a9&ts=true"
import script from "./UnidadeTable.vue?vue&type=script&lang=ts"
export * from "./UnidadeTable.vue?vue&type=script&lang=ts"

import "./UnidadeTable.vue?vue&type=style&index=0&id=2da755a9&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__